import DSBox from "views/system-design/DSBox";

const SEVERITY_COLORS = {
  ERROR: "#dc3545",
  WARNING: "#fd7e14",
} as const;

interface CountBadgeProps {
  count: number;
  severity: "ERROR" | "WARNING";
}

const CountBadge = ({ count, severity }: CountBadgeProps) => {
  const color = SEVERITY_COLORS[severity];
  const label = severity === "ERROR" ? "Error" : "Warning";
  return (
    <DSBox
      sx={{
        bgcolor: color,
        color: "white",
        px: 1.5,
        py: 0.5,
        borderRadius: 10,
        fontSize: 13,
        fontWeight: "bold",
      }}
    >
      {label}: {count}
    </DSBox>
  );
};
export default CountBadge;
